import Footers from './Footers'
export default Footers